import DateTime from "luxon/src/datetime";
import * as yup from "yup";
import { RenderViolationsCell } from "../components/ActTable/ActTable";

export const DynamicFields = {
    TEXT_FIELD: 'text-field',
    MULTILINE_TEXT_FIELD: 'multiline-text-field',
    FULL_NAME_FIELD: 'full-name-field',
    NUMBER_FIELD: 'number-field',
    SELECTED_OFFENSE_LIST: 'selected-offense-list',
    NORMATIVE_ARTICLES_TABLE: 'normative-articles-table',
    CONTRACTOR_VIOLATIONS_TABLE: 'contractor-violations-table',
    NORMATIVE_ARTICLE_SELECT: 'normative-article-select',
    DATE_TIME_SELECT: 'date-time-select',
    REMOVAL_DATE_TIME: 'removal-date-time',
    DRAG_AND_DROP_FILES_UPLOAD: 'drag-and-drop-files-upload',
    DRAG_AND_DROP_ACT_UPLOAD: 'drag-and-drop-act-upload',
    UPLOAD_ANALYSIS: 'upload-analysis',
    AUTOCOMPLETE_SELECT: 'autocomplete-select',
    FREE_AUTOCOMPLETE_SELECT: 'free-autocomplete-select',
    BASE_SELECT: 'base-select',
    CHIP_BLOCK: 'chip-block',
    CHECKBOX_FIELD: 'checkbox-field',
    SIGNATURE_FIELD: 'signature-field',
    QR_CODE_FIELD: 'qr-code-field',
    QR_CODE_VIOLATION: 'qrCodeViolation',
    CHECK_LIST: 'check_list',
    TABLE_CONSTRUCTOR: 'table_constructor',
    SIGNATURE_FOR_TABLE: 'signature-for-table',
    CHART_CONSTRUCTOR: 'chart_constructor',
    TABLE_DATE: 'table-date',
    TABLE_DATE_TIME: 'table-date-time',
    TABLE_MULTILINE: 'table-multiline',
    TABLE_TIME: 'table-time',
}

export const generateFormikInitialValues = (fields) => {
    let initialValues = {}

    for (const field of fields) {
        switch (field.type) {
            case DynamicFields.SELECTED_OFFENSE_LIST:
                initialValues[field.variable] = []
                break
            case DynamicFields.NORMATIVE_ARTICLES_TABLE:
                initialValues[field.variable] = []
                break
            case DynamicFields.CONTRACTOR_VIOLATIONS_TABLE:
                initialValues[field.variable] = []
                break
            case DynamicFields.NORMATIVE_ARTICLE_SELECT:
                initialValues[field.variable] = null
                break
            case DynamicFields.CHIP_BLOCK:
                initialValues[field.variable] = []
                break
            case DynamicFields.REMOVAL_DATE_TIME:
                initialValues[field.variable] = null
                break
            case DynamicFields.CHECKBOX_FIELD:
                initialValues[field.variable] = false
                break
            case DynamicFields.DATE_TIME_SELECT:
                initialValues[field.variable] = DateTime.now()
                break
            case DynamicFields.DRAG_AND_DROP_FILES_UPLOAD:
                initialValues[field.variable] = []
                break
            case DynamicFields.DRAG_AND_DROP_ACT_UPLOAD:
                initialValues[field.variable] = []
                break
            case DynamicFields.UPLOAD_ANALYSIS:
                initialValues[field.variable] = []
                    break
            case DynamicFields.AUTOCOMPLETE_SELECT:
                initialValues[field.variable] = null
                break
            case DynamicFields.FREE_AUTOCOMPLETE_SELECT:
                initialValues[field.variable] = {selectedValue: null, inputValue: ''}
                break
            case DynamicFields.BASE_SELECT:
                initialValues[field.variable] = ''
                break
            default:
                initialValues[field.variable] = ''
        }
    }
    return initialValues
}

const stringValidation = (required = true) => {
    if (required) {
        return yup.string().required('Необходимо заполнить')
    }
    return yup.string()
}

const numberValidation = (required = true) => {
    if (required) {
        return yup.number().required('Необходимо заполнить')
    }
    return yup.number()
}

const autoCompleteValidation = (required = true) => {
    if (required) {
        return yup.object().nullable().test('nonNullable', 'Необходимо заполнить', value => value !== null)
    }
    return yup.object().nullable()
}

const freeAutoCompleteValidation = (required = true) => {
    if (required) {
        return yup.object().nullable().test('nonNullable', 'Необходимо заполнить',
            value => Boolean(value.inputValue))
    }
    return yup.object().nullable()
}

const baseSelectValidation = (required = true) => {
    if (required) {
        return yup.object().shape({
            value: yup.string().required('Необходимо заполнить')
        })
    }
    return yup.object().shape({
        value: yup.string()
    })
}

const normativeArticlesTableValidation = (required = true) => {
    if (required) {
        return yup.array().min(1, 'Добавьте как минимум один нормативный пункт')
    }
    return yup.array()
}

const normativeArticlesSelectValidation = (required = true) => {
    if (required) {
        return yup.object().nullable().test('nonNullable', 'Необходимо заполнить', value => value !== null)
    }
    return yup.object().nullable()
}

export const generateFormikValidationSchema = (fields) => {
    let validationSchema = {}
    for (const field of fields) {
        switch (field.type) {
            case DynamicFields.TEXT_FIELD:
                validationSchema[field.variable] = stringValidation(field?.content?.required)
                break
            case DynamicFields.MULTILINE_TEXT_FIELD:
                validationSchema[field.variable] = stringValidation(field?.content?.required)
                break
            case DynamicFields.FULL_NAME_FIELD:
                validationSchema[field.variable] = yup.object().shape({
                    value: yup.string().required('Необходимо заполнить')
                }).nullable()
                break
            case DynamicFields.NUMBER_FIELD:
                validationSchema[field.variable] = numberValidation(field?.content?.required)
                break
            case DynamicFields.AUTOCOMPLETE_SELECT:
                validationSchema[field.variable] = autoCompleteValidation(field?.content?.required)
                break
            case DynamicFields.FREE_AUTOCOMPLETE_SELECT:
                validationSchema[field.variable] = freeAutoCompleteValidation(field?.content?.required)
                break
            case DynamicFields.BASE_SELECT:
                validationSchema[field.variable] = baseSelectValidation(field?.content?.required)
                break
            case DynamicFields.DATE_TIME_SELECT:
                validationSchema[field.variable] = yup.date().test('dateTimeSelect', value => !!value)
                break
            case DynamicFields.REMOVAL_DATE_TIME:
                validationSchema[field.variable] = yup.date().nullable().test('nonNullable', 'Необходимо заполнить', value => value !== null)
                break
            case DynamicFields.NORMATIVE_ARTICLES_TABLE:
                validationSchema[field.variable] = normativeArticlesTableValidation(field?.content?.required)
                break
            case DynamicFields.CONTRACTOR_VIOLATIONS_TABLE:
                validationSchema[field.variable] = normativeArticlesTableValidation(field?.content?.required)
                break
            case DynamicFields.NORMATIVE_ARTICLE_SELECT:
                validationSchema[field.variable] = normativeArticlesSelectValidation(field?.content?.required)
                break
            case DynamicFields.DRAG_AND_DROP_FILES_UPLOAD:
                validationSchema[field.variable] = yup.array()
                break
            case DynamicFields.CHIP_BLOCK:
                validationSchema[field.variable] = yup.array()
                break
            case DynamicFields.CHECKBOX_FIELD:
                validationSchema[field.variable] = yup.bool().oneOf([true], 'Необходимо заполнить поле')
                break
            case DynamicFields.DRAG_AND_DROP_ACT_UPLOAD:
                validationSchema[field.variable] = yup.array()
                break
            case DynamicFields.UPLOAD_ANALYSIS:
                validationSchema[field.variable] = yup.array()
                break
            case DynamicFields.SELECTED_OFFENSE_LIST:
                validationSchema[field.variable] = yup.array()
                break
            default:
                break
        }
    }
    return yup.object().shape(validationSchema)
}

export const parseFieldVariables = (notAggregatedData, fieldsTemplates) => {
    let ans = {}
    for (const fieldTemplate of fieldsTemplates) {
        switch (fieldTemplate.type) {
            case DynamicFields.FULL_NAME_FIELD:
                ans = {
                    ...ans,
                    [fieldTemplate.variable]: notAggregatedData[fieldTemplate.variable]?.value,
                    ...notAggregatedData[fieldTemplate.variable]?.payload
                }
                break
            case DynamicFields.AUTOCOMPLETE_SELECT:
                ans = {
                    ...ans,
                    [fieldTemplate.variable]: notAggregatedData[fieldTemplate.variable]?.value,
                    ...notAggregatedData[fieldTemplate.variable]?.payload
                }
                break
            case DynamicFields.FREE_AUTOCOMPLETE_SELECT:
                ans = {
                    ...ans,
                    [fieldTemplate.variable]: notAggregatedData[fieldTemplate.variable]?.inputValue,
                }
                break
            case DynamicFields.BASE_SELECT:
                ans = {
                    ...ans,
                    [fieldTemplate.variable]: notAggregatedData[fieldTemplate.variable]?.value,
                    ...notAggregatedData[fieldTemplate.variable]?.payload
                }
                break
            case DynamicFields.DATE_TIME_SELECT:
                for (const format of fieldTemplate?.content?.formats) {
                    if (notAggregatedData[fieldTemplate.variable]?.isLuxonDateTime) {
                        ans[format.variable] = notAggregatedData[fieldTemplate.variable].setLocale('ru').toFormat(format.mask)
                    }
                    if (notAggregatedData[fieldTemplate.variable] &&
                        (typeof notAggregatedData[fieldTemplate.variable] === 'string' ||
                            notAggregatedData[fieldTemplate.variable] instanceof String)
                    ) {
                        ans[format.variable] = DateTime.fromISO(notAggregatedData[fieldTemplate.variable], { zone: 'utc' })
                            .setLocale('ru')
                            .toFormat(format.mask)
                    }
                }
                break
            case DynamicFields.DRAG_AND_DROP_FILES_UPLOAD:
                break
            default:
                ans[fieldTemplate.variable] = notAggregatedData[fieldTemplate.variable]
        }
    }
    return ans
}

export const generateSteps = (fields) => {
    let stepOne = []
    let stepTwo = []
    let stepThree = []

    const sorting = (a, b) => {
        return a.sequenceNumber - b.sequenceNumber
    }

    for (const field of fields) {
        if (field.step === 1) {
            stepOne = [...stepOne, field]
        } else if (field.step === 2) {
            stepTwo = [...stepTwo, field]
        } else if (field.step === 3) {
            stepThree = [...stepThree, field]
        }
    }

    stepOne.sort(sorting)
    stepTwo.sort(sorting)
    stepThree.sort(sorting)
    return [stepOne, stepTwo, stepThree]
}

export const fieldTemplateToColumn = fieldTemplate => {
    if (fieldTemplate?.type === 'skan') return {
        field: fieldTemplate.variable,
        headerName: fieldTemplate.label,
        flex: 1,
        onion: 1,
        width: 120,
        filterable: false,
        sortable: false,
        type: fieldTemplate.type
    }
    if (fieldTemplate?.father !== undefined) return {
        field: fieldTemplate.variable,
        headerName: fieldTemplate.label,
        flex: 2,
        onion: 2,
        father: fieldTemplate.father,
        type: fieldTemplate.type
    }
    return {
        field: fieldTemplate.variable,
        headerName: fieldTemplate.label,
        flex: 1,
        onion: 1,
        type: fieldTemplate.type,
    }
}